
import { Id, RemoteData } from 'app/infrastructure/remote-data';
import { DashboardLayoutDefinition } from './types-store';
import { FavouriteDefinition, ApiResponse, TextCollection } from 'app/types-shared';
import { DrillDownModel, DrillDownResult } from 'app/components/favourite-layout/favourite/common/drill-down-model';

export const endpoint = {
  dashboard: 'dashboard',
  dashboardFavouriteDefinition: 'favourite/definition/draft',
  dashboardMainDefinition: 'favourite/definition/draft/template/dashboard',
  updateMainDefinition: 'favourite/definition/draft',
  favourite: 'statisticalReport'
};

export const api = {

  /**
   * Fetch a favourite in the context of a dashboard.
   */
  executeFavourite: async (definition: FavouriteDefinition, dashboardId: number) => {

    const request = {
      favouriteDefinition: definition,
      connectedFavourite: dashboardId
    };

    const response = await new RemoteData(`${endpoint.dashboard}/${dashboardId}/favourite/${definition.favourite.v}`)
      .resource<any>()
      .create(request, false);

    const json = await response.json();

    json.data.id = json.data.favourite;

    return json.data;
  },

  /**
   * Fetch the dashboard type definition.
   */
  dashboardLayoutDefinition: async (dashboardType: Id, layoutTypeContextId: number): Promise<DashboardLayoutDefinition> => {
    const response = await new RemoteData(endpoint.dashboard)
      .resource<ApiResponse<DashboardLayoutDefinition>>()
      .withId(dashboardType)
      .filter({
        layoutTypeContextId: layoutTypeContextId
      })
      .single();

    return response.data;
  },

  /**
   * Creates dashboard main favourite and return its number.
   */
  createMainFavourite: async (
    dashboardType: Id,
    queryParameters?: {[key:string]: string | number}
    ): Promise<number> => {
    const response = await new RemoteData(endpoint.dashboardMainDefinition)
      .resource<any>()
      .filter({
        dashboardType,
        ...queryParameters
      })
      .create(undefined, false);

    const json = await response.json();

    return json.data;
  },

  /**
   * Drill down from dashboard.
   */
  drillDown: async (dashboardId: number, favouriteId: number, drillDownModel: DrillDownModel): Promise<DrillDownResult> => {
    const response: any = await new RemoteData(`${endpoint.dashboard}/${dashboardId}/favourite/${favouriteId}/drilldown`)
      .resource<ApiResponse<DrillDownResult>>()
      .create(drillDownModel, false);

    const json = await response.json();

    return json.data;
  },

  /**
   * Fetch tranlated texts for a given application area
   */
  textCollection: async (area: number): Promise<TextCollection> => {
    const remote = new RemoteData('text/collection');
    const response: any = await remote.resource<TextCollection>().withId(area).single();
    return response.data;
  }
};
